import { Icon, IconButton, IconButtonProps } from '@chakra-ui/react';
import { ReactComponent as ChevronIcon } from 'resources/images/chevron-down.svg';

interface BackButtonProps extends Omit<IconButtonProps, 'aria-label'> {}

export const BackButton = (props: BackButtonProps) => {
  return (
    <IconButton
      variant="text"
      size="lg"
      color="textSubdued"
      aria-label="back button"
      zIndex={1}
      position="absolute"
      top={16}
      left={12}
      {...props}
    >
      <Icon
        as={ChevronIcon}
        width={5}
        height={5}
        transform="rotate(90deg)"
        fill="M.60"
        _hover={{ fill: 'M.70' }}
      />
    </IconButton>
  );
};
